/**
 * payDataVatApi — RTK Query slice cho /purchase/pay-data-vat/* (Procurement
 * Pay Data → Send VAT). Dedicated slice (KHÔNG đụng payDataApi.ts).
 *
 * BE trả snake_case (không alias) → giữ nguyên shape snake_case ở FE để bảng
 * map 1:1 subform `frmProcurementQryPayDataSendVAT`.
 */
import { baseApi } from './baseApi'

export interface VatInvoiceItem {
  invoice_id: number | null
  invoice_no: string | null
  contract_no: string | null
  invoice_date: string | null
  cp_code: string | null
  contract_name: string | null
  vat_amount: number | null
  total_amount: number | null
  total_amount_after_tax: number | null
  paid_vat_date: string | null
  paid_vat_value: number | null
  paid_vat_txt: string | null
}

export interface VatInvoiceListResponse {
  items: VatInvoiceItem[]
  total: number
}

export interface VatBankItem {
  bank_account: string | null
  cp_code: string | null
  bank: string | null
  bank_info: string | null
}

export interface VatBankListResponse {
  items: VatBankItem[]
  total: number
}

export interface VatInvoiceListQuery {
  cp_code?: string
  contract_no?: string
  date_from?: string
  date_to?: string
}

export interface VatSubmitInvoice {
  invoice_no: string
  contract_no: string
  vat_amount: number | null
}

export interface VatSubmitPayload {
  paid_date: string | null
  bank_account: string | null
  cp_code?: string | null
  invoices: VatSubmitInvoice[]
}

export interface VatSubmitResult {
  inserted: number
  soft_deleted: number
  message: string
}

export const payDataVatApi = baseApi.injectEndpoints({
  endpoints: (b) => ({
    listVatInvoices: b.query<VatInvoiceListResponse, VatInvoiceListQuery | void>({
      query: (params) => ({ url: '/purchase/pay-data-vat/invoices', params: params ?? {} }),
    }),
    listVatBanks: b.query<VatBankListResponse, { cp_code?: string } | void>({
      query: (params) => ({ url: '/purchase/pay-data-vat/banks', params: params ?? {} }),
    }),
    submitVat: b.mutation<VatSubmitResult, VatSubmitPayload>({
      query: (body) => ({ url: '/purchase/pay-data-vat/submit', method: 'POST', body }),
      // Invalidate Pay Data list (declared VAT can change downstream views).
      invalidatesTags: [{ type: 'PayData', id: 'LIST' }],
    }),
  }),
  overrideExisting: false,
})

export const { useListVatInvoicesQuery, useListVatBanksQuery, useSubmitVatMutation } =
  payDataVatApi
